import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next'
import configData from '../../../temp/config';
import AgeLists from './AgeLists'

const ResultList = (props) => {
  const[fetchdata, setFetchdata] = useState({
    title:'',
    href:'',
    ageList:[],   
    duration:[],     
    thumbnail:'',
    shortdescription:''
  })
  /* Assign Variable for Pagination */
  const [currentPage, setCurrentPage] = useState(1)
  useEffect(() => {
    setFetchdata(fetchdata => ({
        title: props.data.title,
        href: props.data.detailLink,
        ageList: props.data.ageList,
        duration: props.data.duration,
        thumbnail: props.data.thumbnail,
        shortdescription: props.data.summary
    }))        
  },[props.data])

  //Navigate to the page
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const { t } = props;

  return(
    <div className="resultlist">
        {
            fetchdata.thumbnail.src !== '' &&
            <div className="imgblk">
                <a href={`${fetchdata.href.toLowerCase()}`}><img src={`${configData.sitecoreApiHost}${fetchdata.thumbnail.src}`} /></a>
            </div>
        }
        <div className="infolblk">
            <h4>
                <a href={`${decodeURI(fetchdata.href.toLowerCase())}`}
                    //onClick={(e) => recipeDetail(e, fetchdata.title)}
                >
                    {fetchdata.title}
                </a>
            </h4>
            {
              fetchdata.ageList.length > 0 &&
              <p className="ageblk">
                <span className="agelabel">{t('RecipeFinder_Age')}</span>
                
                  <AgeLists
                    ages={fetchdata.ageList}
                  />                          
              </p>
            }    
            {
                fetchdata.duration.length > 0 &&
              <p className="ageblk">
                <span className="agelabel">{t('RecipeFinder_Duration')}</span>
                
                  <AgeLists
                    ages={fetchdata.duration}
                  />           
              </p>
            }   
            <p>{fetchdata.shortdescription}</p>
        </div>
    </div>
  )  
};

export default withTranslation()(ResultList);